import { useMemo, useState } from 'react'
import * as DiariasHttp from '../../../../../services/api/https/registration/diarias-veiculo.http'
import * as VeiculoHttp from '../../../../../services/api/https/registration/veiculo.http'
import { errorHandler } from '../../../../../services/util/error.service'

export const LOAD_MESSAGE = { NONE: 'NONE', LOADING: 'Carregando...' }

const INITIAL_STATE = {
  diarias: [],
  tiposVeiculos: [],
  selectedTp: 0,
  selectedEmpresa: null,
  globalFilter: '',
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: '',
  modal: { show: false, data: null },
}

export default function useDiariasPorVeiculo() {
  const [state, setState] = useState(INITIAL_STATE)

  const localDispatch = useMemo(
    () => ({
      /* ---------- init ---------- */
      async onInit(selectedTp) {
        try {
          if (!selectedTp)
            return setState(p => ({
              ...p,
              errorMessage: 'Selecione um Operador Logístico',
            }))

          /* pega a mesma lista usada no cadastro de veículos */
          const infoIniciais = await VeiculoHttp.getVeiculoInfoIniciais(selectedTp)
          const tiposVeiculos = infoIniciais.manufacturers || []
          setState(p => ({ ...p, tiposVeiculos, selectedTp }))
        } catch (err) {
          errorHandler(err)
        }
      },

      /* ---------- empresa ---------- */
      async onEmpresaChange(empresa) {
        setState(p => ({
          ...p,
          selectedEmpresa: empresa,
          diarias: [],
          loadingMessage: LOAD_MESSAGE.LOADING,
        }))
        try {
          const diarias = await DiariasHttp.getDiarias({
            tp_id: state.selectedTp,
            company_id: empresa.id,
          })
          setState(p => ({ ...p, diarias, loadingMessage: LOAD_MESSAGE.NONE }))
        } catch (err) {
          errorHandler(err)
          setState(p => ({ ...p, loadingMessage: LOAD_MESSAGE.NONE }))
        }
      },

      /* ---------- botões ---------- */
      onBtnNovo() {
        if (!state.selectedEmpresa)
          return setState(p => ({
            ...p,
            errorMessage: 'Escolha uma empresa antes de cadastrar.',
          }))
        setState(p => ({ ...p, modal: { show: true, data: null } }))
      },

      onDataTableItemClicked(row) {
        setState(p => ({ ...p, modal: { show: true, data: { ...row } } }))
      },

      /* ---------- modal ---------- */
      onModalClose() {
        setState(p => ({ ...p, modal: { show: false, data: null } }))
      },

      async onModalSave(diaria) {
        try {
          setState(p => ({ ...p, loadingMessage: LOAD_MESSAGE.LOADING }))

          let saved
          if (diaria.id) {
            /* ----------- EDIÇÃO: envia o objeto completo ----------- */
            const payload = {
              id: diaria.id,
              day: diaria.day,
              manufacturer_id: diaria.manufacturer_id,
              company_id: state.selectedEmpresa.id,
              tp_id: state.selectedTp,
              value: diaria.value,
            }
            await DiariasHttp.updateDiaria(payload)
            saved = { ...payload }
          } else {
            /* ----------- NOVO registro ----------- */
            const novo = {
              ...diaria,
              company_id: state.selectedEmpresa.id,
              tp_id: state.selectedTp,
            }
            const res = await DiariasHttp.saveDiarias([novo])
            saved = res[0]
          }

          setState(p => ({
            ...p,
            diarias: insertOrReplace(p.diarias, saved),
            loadingMessage: LOAD_MESSAGE.NONE,
            modal: { show: false, data: null },
          }))
        } catch (err) {
          errorHandler(err)
          setState(p => ({ ...p, loadingMessage: LOAD_MESSAGE.NONE }))
        }
      },

      onGlobalFilterChange(value) {
        setState(p => ({ ...p, globalFilter: value }))
      },
    }),
    [state.selectedTp, state.diarias, state.selectedEmpresa],
  )

  return { state, localDispatch }
}

function insertOrReplace(list, item) {
  const i = list.findIndex(l => l.id === item.id)
  if (i >= 0) {
    const clone = [...list]
    clone[i] = item
    return clone
  }
  return [item, ...list]
}
